<template>
  <div>
    <z-title class="recover-password-channel__title" tag="h1" size="medium">
      Valide que esta é a sua conta
    </z-title>
    <z-text size="medium">
      Selecione por onde deseja receber o código de validação
    </z-text>

    <div class="recover-password-channel__selection">
      <div class="recover-password-channel__channel-wrapper" @click="generateConfirmationToken('email')">
        <z-card
          size="small"
          class="recover-password-channel__channel"
          v-if="channels.email"
        >
          <z-icon :icon="['far', 'envelope']" size="large" color="primary" />
          <div class="channel__description">
            <z-text tag="div" size="medium" weight="bold" color="major">
              Validar via e-mail
            </z-text>
            <z-text tag="div" size="small" color="minor">
              {{ channels.email }}
            </z-text>
          </div>
        </z-card>
      </div>

      <div class="recover-password-channel__channel-wrapper" @click="generateConfirmationToken('sms')">
        <z-card
          size="small"
          class="recover-password-channel__channel"
          v-if="channels.cellphone"
        >
          <z-icon :icon="['fas', 'mobile-alt']" size="large" color="primary" />
          <div class="channel__description">
            <z-text tag="div" size="medium" weight="bold" color="major">
              Validar via SMS
            </z-text>
            <z-text tag="div" size="small" color="minor">
              {{ channels.cellphone }}
            </z-text>
          </div>
        </z-card>
      </div>
    </div>
  </div>
</template>

<script>
import { FormGroup } from 'utils/form';
import CurrentStudentService from 'services/CurrentStudentService';

export default {
  data() {
    return {
      channels: {},
      passwordRecoverChannelForm: new FormGroup({
        cpfHash: { value: '' },
        channel: { value: '' },
        type: { value: '' },
      }),
    };
  },
  beforeMount() {
    this.passwordRecoverChannelForm.addValues({
      cpfHash: this.$route.params.cpfHash,
      type: this.$route.meta.channelType,
    });

    this.getRecoverPasswordChannels();
  },
  methods: {
    getRecoverPasswordChannels() {
      this.$pageLoader.show('Carregando');

      CurrentStudentService.loadRecoverPasswordChannels(this.passwordRecoverChannelForm.getValue('cpfHash'))
        .then((response) => {
          this.channels = response;
        })
        .catch(() => {
          this.$router.push({ name: 'login' });
        })
        .finally(() => {
          this.$pageLoader.hide();
        });
    },
    generateConfirmationToken(channel) {
      this.$pageLoader.show('Carregando');

      this.passwordRecoverChannelForm.addValues({ channel });

      CurrentStudentService.generateConfirmationToken(this.passwordRecoverChannelForm.getRawValue())
        .then(() => {
          this.$emit('channel-selected', { channel, value: this.channels[channel] });
        })
        .catch(() => {
          this.$router.push({ name: 'login' });
        })
        .finally(() => {
          this.$pageLoader.hide();
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.recover-password-channel__title {
  margin-bottom: var(--space-extra-large);
}

.recover-password-channel__selection {
  margin-top: var(--space-extra-large);
}

.recover-password-channel__channel-wrapper {
  cursor: pointer;
  margin-bottom: var(--space-medium);
}

.recover-password-channel__channel {
  align-items: center;
  display: flex;
  flex-direction: row;
}

.channel__description {
  display: inline-block;
  margin-left: var(--space-medium);
}
</style>
